import { service } from "../../../services";

const state = {
  items: [],
  loading: false,
  error: null
};

const mutations = {
  setTribes(state, tribes) {
    state.items = tribes;
  },

  setError(state, error) {
    state.error = error;
  }
};

const actions = {
  fetchTribes({ commit }) {
    try {
      service.get("/tribes").then(res => {
        commit("setTribes", res.items);
      });
    } catch (err) {
      commit("setError", err.message);
    }
  }
};

export const tribes = {
  namespaced: true,
  state,
  mutations,
  actions
};
